var iFitSubscribe = (function() { //eslint-disable-line no-unused-vars
  var host = location.host;
  var isProd = /ifitnourish(?:\.myshopify)?\.com/.test(host);
  var longHost = isProd ? 'ifitnourish.myshopify.com' : host;
  var shop = longHost.split('.')[0];
  var backend = isProd ? 'https://api.ifit.com' : 'https://api-local.ifit-dev.com:8443';

  var skuData = [
    {
      sku: 'IFNPCMC',
      calories: 190,
      protein: 20,
      oz: 30,
      g: 855,
      formula: 43734
    },
    {
      sku: 'IFNPCMV',
      calories: 190,
      protein: 20,
      oz: 30,
      g: 840,
      formula: 13301
    },
    {
      sku: 'IFNPCFC',
      calories: 150,
      protein: 15,
      oz: 24,
      g: 675,
      formula: 30177
    },
    {
      sku: 'IFNPCFV',
      calories: 150,
      protein: 15,
      oz: 23,
      g: 660,
      formula: 23287
    },
    {
      sku: 'IFNPWMC',
      calories: 110,
      protein: 18,
      oz: 19,
      g: 525,
      formula: 58690
    },
    {
      sku: 'IFNPWMV',
      calories: 110,
      protein: 18,
      oz: 18,
      g: 518,
      formula: 80877
    },
    {
      sku: 'IFNPWFC',
      calories: 90,
      protein: 16,
      oz: 15,
      g: 435,
      formula: 71534
    },
    {
      sku: 'IFNPWFV',
      calories: 90,
      protein: 16,
      oz: 15,
      g: 420,
      formula: 33617
    },
    {
      sku: 'IFNPLMC',
      calories: 160,
      protein: 30,
      oz: 23,
      g: 645,
      formula: 34317
    },
    {
      sku: 'IFNPLMV',
      calories: 160,
      protein: 30,
      oz: 23,
      g: 645,
      formula: 24671
    },
    {
      sku: 'IFNPLFC',
      calories: 130,
      protein: 25,
      oz: 19,
      g: 540,
      formula: 12320
    },
    {
      sku: 'IFNPLFV',
      calories: 130,
      protein: 25,
      oz: 19,
      g: 533,
      formula: 19177
    },
    {
      sku: 'IFNPPMC',
      calories: 160,
      protein: 20,
      oz: 25,
      g: 713,
      formula: 49486
    },
    {
      sku: 'IFNPPMV',
      calories: 150,
      protein: 20,
      oz: 24,
      g: 690,
      formula: 59513
    },
    {
      sku: 'IFNPPFC',
      calories: 150,
      protein: 20,
      oz: 23,
      g: 645,
      formula: 74464
    },
    {
      sku: 'IFNPPFV',
      calories: 140,
      protein: 20,
      oz: 22,
      g: 623,
      formula: 74170
    },
    {
      sku: 'IFNMCMC',
      calories: 260,
      protein: 24,
      oz: 41,
      g: 1155,
      formula: 11565
    },
    {
      sku: 'IFNMCMV',
      calories: 260,
      protein: 24,
      oz: 40,
      g: 1140,
      formula: 92696
    },
    {
      sku: 'IFNMCFC',
      calories: 230,
      protein: 21,
      oz: 36,
      g: 1013,
      formula: 23233
    },
    {
      sku: 'IFNMCFV',
      calories: 230,
      protein: 21,
      oz: 35,
      g: 1005,
      formula: 33747
    },
    {
      sku: 'IFNMWMC',
      calories: 160,
      protein: 22,
      oz: 26,
      g: 750,
      formula: 24760
    },
    {
      sku: 'IFNMWMV',
      calories: 160,
      protein: 22,
      oz: 26,
      g: 735,
      formula: 43293
    },
    {
      sku: 'IFNMWFC',
      calories: 130,
      protein: 20,
      oz: 21,
      g: 608,
      formula: 34263
    },
    {
      sku: 'IFNMWFV',
      calories: 130,
      protein: 20,
      oz: 22,
      g: 615,
      formula: 14625
    },
    {
      sku: 'IFNMLMC',
      calories: 230,
      protein: 40,
      oz: 35,
      g: 1005,
      formula: 41359
    },
    {
      sku: 'IFNMLMV',
      calories: 220,
      protein: 40,
      oz: 35,
      g: 990,
      formula: 97522
    },
    {
      sku: 'IFNMLFC',
      calories: 180,
      protein: 30,
      oz: 29,
      g: 825,
      formula: 36370
    },
    {
      sku: 'IFNMLFV',
      calories: 180,
      protein: 30,
      oz: 29,
      g: 810,
      formula: 20584
    },
    {
      sku: 'IFNMPMC',
      calories: 190,
      protein: 25,
      oz: 30,
      g: 840,
      formula: 55961
    },
    {
      sku: 'IFNMPMV',
      calories: 190,
      protein: 25,
      oz: 29,
      g: 825,
      formula: 93634
    },
    {
      sku: 'IFNMPFC',
      calories: 160,
      protein: 20,
      oz: 26,
      g: 735,
      formula: 29662
    },
    {
      sku: 'IFNMPFV',
      calories: 160,
      protein: 20,
      oz: 25,
      g: 705,
      formula: 63769
    }
  ];

  var htmlEncode = (function() {
    var encoder = document.createElement('span');
    return function(text) {
      encoder.innerText = text;
      return encoder.innerHTML;
    };
  })();

  function template(id, values, encode) {
    if (encode === false) {
      encode = function(value) {
        return value;
      };
    } else {
      encode = htmlEncode;
    }
    return $('#' + id).html().replace(/{\s*([a-z0-9]*)\s*}/gi, function(_, tag) {
      var value = values[tag];
      if (value === 'undefined') {
        value = '';
      }
      return encode(value);
    });
  }

  function skuInfo(sku) {
    sku = String(sku).substr(0, 7).toUpperCase();
    for (var i = 0; i < skuData.length; i++) {
      if (skuData[i].sku === sku) return skuData[i];
    }
  }

  function checkBold(cb) {
    if (!window.BOLD) {
      var err = new Error('Bold app not found');
      if (!cb) {
        throw err;
      } else {
        cb(err);
        return false;
      }
    }
    return window.BOLD;
  }

  /**
   * @param {string} [task]
   * @param {boolean} [parallel]
   * @param {[function]}  funcs
   * @param {function} [cb]
   * @return {undefined}
   */

  function async(task, parallel, funcs, cb) {
    if (typeof task !== 'string') {
      cb = funcs;
      funcs = parallel;
      parallel = task;
      task = '';
      if (tasks.length) {
        task = tasks[0];
      }
    }

    if (typeof parallel !== 'boolean') {
      cb = funcs;
      funcs = parallel;
      parallel = false;
    }

    cb = cb || function(err) {
      if (err) {
        setTimeout(function() {
          throw err;
        }, 1);
      }
    };

    if (parallel) {
      return (function() {
        var cbCalled = false;
        var results = [];
        var todo = funcs.length;
        var done = 0;

        funcs.forEach(function(func, ix) {
          if (!func.length) {
            try {
              withTask(task, function() {
                callComplete(ix, null, func());
              });
            } catch (err) {
              callComplete(ix, err);
            }
            return;
          }
          withTask(task, function() {
            func(callComplete.bind(null, ix));
          });
        });
        return;

        function callCb() {
          if (cbCalled) return;
          cbCalled = true;
          try {
            cb.apply(null, arguments);
          } catch (err) {
            setTimeout(function() {
              throw err;
            }, 1);
          }
        }

        function callComplete(ix, err, result) {
          if (err) return callCb(err);
          done++;
          results[ix] = result;
          if (done === todo) {
            callCb(null, results);
          }
        }
      })();
    }

    var toDo = funcs.slice(1);
    var current = funcs[0];
    if (!current) return cb();
    if (!current.length) {
      try {
        withTask(task, function() {
          current();
        });
      } catch (err) {
        return cb(err);
      }
      async(task, toDo, cb);
    } else {
      var cbCalled = false;
      withTask(task, function() {
        current(function(err) {
          if (cbCalled) {
            throw new Error('Callback invoked more than once from ' + current.name);
          }
          cbCalled = true;
          if (err) return cb(err);
          async(toDo, cb);
        });
      });
    }
  }

  /**
   * @param {string} [task]
   * @param {array}  array
   * @param {function} func
   * @param {function} cb
   * @return {undefined}
   */

  function mapSerial(task, array, func, cb) {
    if (typeof task === 'string') {
      return withTask(task, function() {
        return mapSerial(array, func, cb);
      });
    } else {
      cb = func;
      func = array;
      array = task;
      task = '';
      if (tasks.length) {
        task = tasks[0];
      }
    }
    array = array.slice();
    var result = [];
    next();

    function next() {
      if (!array.length) return cb(null, result);
      var v = array.shift();
      withTask(task, function() {
        func(v, function(err, res) {
          if (err) return cb(err);
          result.push(res);
          next();
        });
      });
    }
  }

  var originalAjax = $.ajax;
  $.ajax = function(options) {
    if (arguments.length === 1 && options && typeof options === 'object' && typeof options.success === 'function' && tasks.length) {
      var task = tasks[0];
      var newOptions = $.extend({}, options);
      newOptions.success = function() {
        var self = this;
        var args = arguments;
        return withTask(task, function() {
          return options.success.apply(self, args);
        });
      };
      return originalAjax.call(this, newOptions);
    }
    return originalAjax.apply(this, arguments);
  };

  function apiUrl(path, checkout, params) {
    if (typeof checkout !== 'boolean') {
      params = checkout;
      checkout = false;
    }
    var base = checkout ? 'https://recurringcheckout.com/s/' + shop : 'https://' + host + '/tools/checkout';
    var url = base + '/front_end/' + (path || '');
    return params ? makeGetUrl(url, params) : url;
  }

  function isLoggedIn() {
    var BOLD = checkBold();
    return Boolean(BOLD.customer && BOLD.customer.id);
  }

  var tasks = [];
  function withTask(task, cb) {
    if (!task) return cb();
    tasks.push(task);
    try {
      return cb();
    } finally {
      tasks.pop();
    }
  }

  function taskErrorMessage(message, task) {
    if (!task && tasks.length) {
      task = tasks[0];
    }
    return message + (task ? ' while ' + task : '');
  }

  function taskError(message, task) {
    return new Error(taskErrorMessage(message, task));
  }

  function ajaxError(cb, task, ignoreStatuses) {
    ignoreStatuses = (ignoreStatuses || []).map(Number);
    if (tasks.length) {
      task = tasks[0];
    }
    var stack = (new Error()).stack;
    return function(xhr, textStatus, errorThrown) {
      //"timeout", "error", "abort", and "parsererror"
      var message;
      if (textStatus === 'timeout') {
        message = 'Timed waiting for server response';
      } else if (textStatus === 'abort' || xhr.status === 0) {
        message = 'The request was aborted';
      } else if (textStatus === 'parsererror') {
        message = 'The response from the server could not be parsed';
      } else {
        if (ignoreStatuses.indexOf(xhr.status) !== -1) {
          return cb();
        }
        message = xhr.responseText;
        if (!message || message.length > 500 || /$\s*</.test(message)) {
          var errors = {
            400: 'bad request',
            401: 'authorization',
            403: 'access denied',
            404: 'resource not found',
            500: 'internal server',
            502: 'bad gateway',
            503: 'service unavailable',
            504: 'gateway timeout',
          };
          var status = xhr.status;
          if (!errors[status]) {
            status = Math.floor(status / 100) * 100;
          }
          if (errors[status]) {
            message = normalizeMessage(errors[status]);
          } else if (errorThrown) {
            message = normalizeMessage(errorThrown);
          } else {
            message = normalizeMessage('http error ' + xhr.status);
          }
        }
      }
      var err = taskError(message, task);
      if (stack) {
        try {
          err.stack = err.message + '\n' + stack;
          err.tasks = tasks.slice().concat(task ? task : []).join(', ');
        } catch (err) {
          //ignore
        }
      }
      cb(err);
    };

    function normalizeMessage(text) {
      return ((/^(?:[aeoui]|$|http)/i.test(text) ? 'An ' : 'A ') + text.toLowerCase() + ' error occurred').replace(/\s+/g, ' ');
    }
  }

  var boldCredentials;
  var boldCredentialsPending;
  function getBoldCredentials(cb) {
    if (boldCredentials) return cb(null, boldCredentials);
    if (!isLoggedIn()) return cb(taskError('Not logged in'));
    if (boldCredentialsPending) {
      boldCredentialsPending.push(cb);
      return;
    }
    var BOLD = checkBold(cb);
    if (!BOLD) return;
    var customer = BOLD.customer;
    if (!customer) return cb(taskError('Customer not logged in'));

    boldCredentialsPending = [];
    $.ajax({
      url: 'https://' + host + '/tools/checkout/front_end/check_login/' + customer.id,
      type: 'get',
      success: function(response) {
        var result = {};
        var err = null;
        var props = ['bold_token', 'bold_signature'];

        props.forEach(function(name) {
          result[name] = fetchProp(name);
        });

        boldCredentials = result;
        cb(err, result);
        boldCredentialsPending.forEach(function(cb) {
          cb(err, result);
        });
        function fetchProp(name) {
          var match = (new RegExp('[&\?]' + name + '=([^&"]*)[&"]')).exec(response);
          if (!match) {
            err = taskError(name + ' not found in Bold form');
            return;
          }
          return match[1];
        }
      },
      error: ajaxError(cb, 'getting credentials')
    });
  }

  function getCreditCardInfo(creditCardType) {
    var cardDigits = 16; // Assume 16 for variable digit count cards

    if (/american *express|amex/i.test(creditCardType)) {
      cardDigits = 15;
    } else if (/diners|enroute|blanche/i.test(creditCardType)) {
      cardDigits = 14;
    }

    var cards = {
      visa: /visa/,
      mastercard: /mastercard/,
      discover: /discover/,
      amex: /american *express|amex/,
      jcb: /jcb/,
      'diners-club': /diners|enroute|blanche/
    };
    var iconClass = 'fa-credit-card';
    Object.keys(cards).forEach(function(cardName) { //eslint-disable-line no-loop-func
      if (cards[cardName].test(creditCardType.toLowerCase())) {
        iconClass = 'fa-cc-' + cardName;
      }
    });

    return {
      type: creditCardType,
      cardDigits: cardDigits,
      iconClass: iconClass,
    };
  }

  function getSubscriptions(cb) {
    var credentials;
    var subscriptions;
    async('retrieving subscriptions', [
      function(next) {
        getBoldCredentials(function(err, _credentials) {
          credentials = _credentials;
          next(err);
        });
      },
      function(next) {
        $.ajax({
          url: apiUrl('recurring_orders'),
          type: 'get',
          data: credentials,
          success: function(response) {
            var subsSrc = / recurring_products_table[\s\S]*<\/table>/.exec(response)[0];
            var subSrcList = subsSrc.match(/ td_order_number[\s\S]*upcoming_orders[\s\S]*<\/table>[\s\S]*<\/table>/g) || [];
            var subSrc;
            var subs = {};
            var sub;
            var orderId;
            var expiry;
            var stripeKey = /var stripe = Stripe\('([^']+)'\);/.exec(response);
            stripeKey = stripeKey && stripeKey[1];
            for (var i = 0; i < subSrcList.length; i++) {
              subSrc = subSrcList[i];
              orderId = grab(/data-order-id="(\d+)"/);
              sub = {
                orderNumber: grab(/ td_order_number.*<a.*?Order #(\d+)</),
                dateCreated: grab(/"td_date_created_label.*?<\/strong>\s*(.*?)</),
                frequency: grab(/"td_frequency_label.*?<\/strong><.*?>\s*(.*?)\s*</),
                lastPayment: (grab(/"td_last_payment_label.*?<\/strong><.*?>\s*(.*?)\s*</) || '').toLowerCase() || undefined,
                orderId: orderId
              };
              subs[orderId] = sub;
              expiry = grab(/Expires:[\s\S]*?<span>(.*?)</);
              if (expiry) {
                expiry = expiry.split(/\s*\/\s*/);
                expiry = {
                  month: Number(expiry[0]),
                  year: Number(expiry[1])
                };
              }

              var creditCardType = grab(/Type:[\s\S]*?<span>(.*?)</);

              sub.creditCard = $.extend({
                lastFour: grab(/Last 4 digits[\s\S]*?<span>(\d+)</),
                expiry: expiry,
                stripeKey: stripeKey
              }, getCreditCardInfo(creditCardType));
              sub.shipping = getAddress(false);
              sub.billing = getAddress(true);

              sub.orders = [];
            }
            var orderRegExp = /class="(skip|recover)_order" data-id="[^"]*" data-date="([^"]*)">/g;

            var match;
            while (match = orderRegExp.exec(subSrc)) { //eslint-disable-line no-cond-assign
              sub.orders.push({
                skipped: match[1] === 'recover',
                date: match[2]
              });
            }
            subscriptions = subs;
            next();

            function grab(regExp) {
              var match = regExp.exec(subSrc);
              if (!match) return;
              return match[1];
            }

            function getAddress(billing) {
              var prefix = billing ? 'billing_' : '';
              var address = {
                firstName: input('first_name'),
                lastName: input('last_name'),
                street1: input('address1'),
                street2: input('address2'),
                country: select('country'),
                province: grab(new RegExp('data-' + prefix.replace('_', '-') + 'province = "([^"]*?)"')),
                city: input('city'),
                zip: input('zip'),
                phone: input('phone')
              };

              return address;

              function input(name) {
                return grab(new RegExp('input.*?name="' + prefix + name + '".*?value="([^"]*?)"'));
              }

              function select(name) {
                return grab(new RegExp('select.*?name="' + prefix + name + '"[\\s\\S]*?option value="([^"]*?)"[^>]*?text=[^>]*?selected'));
              }
            }
          },
          error: ajaxError(next)
        });
      }
    ], function(err) {
      if (err) return cb(err);
      cb(null, subscriptions);
    });
  }

  function skipShipSubscriptionOrder(subscriptionId, date, kind, cb) {
    kind = String(kind).toLowerCase();
    var ship = ['recover', 'ship', 'resume'].indexOf(kind) !== -1;
    var skip = !ship && ['cancel', 'skip'].indexOf(kind) !== -1;
    if (!ship && !skip) return cb(taskError('kind must be "skip" or "ship"'));
    var action = skip ? 'skip' : 'recover';
    withTask((skip ? 'skipping' : 'resuming') + ' a shipment', function() {
      getBoldCredentials(function(err, credentials) {
        if (err) return cb(err);
        /* eslint-disable camelcase */
        $.ajax({
          url: apiUrl(action + '_order'),
          type: 'post',
          dataType: 'text',
          data: {
            id: subscriptionId,
            order_date: date,
            bold_token: credentials.bold_token,
            bold_signature: credentials.bold_signature
          },
          success: function() {
            cb();
          },
          error: ajaxError(cb, action + ' a shipment', [302])
        });
        /* eslint-enable camelcase */
      });
    });
  }

  function dateAsIso(date) {
    return date.getFullYear() + '-' + pad(date.getMonth() + 1) + '-' + pad(date.getDate());

    function pad(value) {
      value = String(value);
      if (value.length < 2) value = '0' + value;
      return value;
    }
  }

  function setNextOrderDate(subscriptionId, newDate, cb) {
    if (newDate instanceof Date) {
      newDate = dateAsIso(newDate);
    }
    getBoldCredentials(function(err, credentials) {
      if (err) return cb(err);
      /* eslint-disable camelcase */
      $.ajax({
        url: apiUrl('save_new_ship_date/' + subscriptionId),
        type: 'post',
        dataType: 'text',
        data: {
          next_shipping_date: newDate,
          bold_token: credentials.bold_token,
          bold_signature: credentials.bold_signature
        },
        success: function() {
          cb();
        },
        error: ajaxError(cb, 'setting the subscription\'s next order date', [302])
      });
      /* eslint-enable camelcase */
    });
  }

  function getSubscriptionInfo(subscriptionId, cb) {
    var credentials;
    var products = [];
    async('retrieving subscriptions', [
      function(next) {
        getBoldCredentials(function(err, _credentials) {
          credentials = _credentials;
          next(err);
        });
      },
      function(next) {
        $.ajax({
          url: apiUrl('view_products/' + subscriptionId),
          type: 'get',
          data: credentials,
          success: function(response) {
            var regExp = /<td><img src="([^"]*)".*?<\/td><td>(.*?)<\/td><td>(.*?)<\/td><td>(.*?)<\/td><td>(.*?)<\/td><td><input type="text" name=quantity\[] value="(.*?)"><\/td><td>.*?data-product-internal-id="([^"]*)"><\/td>/g;
            var match;
            while (match = regExp.exec(response)) { //eslint-disable-line no-cond-assign
              products.push({
                img: match[1],
                name: match[2],
                variant: match[3],
                sku: match[4],
                price: match[5],
                quantity: match[6],
                internalProductId: match[7]
              });
            }
            next(null);
          },
          error: ajaxError(next)
        });
      },
    ], function(err) {
      if (err) return cb(err);
      cb(null, products);
    });
  }

  function getDiscountCode(subscriptionId, cb) {
    var credentials;
    var discount;
    async('retrieving subscriptions', [
      function(next) {
        getBoldCredentials(function(err, _credentials) {
          credentials = _credentials;
          next(err);
        });
      },
      function(next) {
        $.ajax({
          url: apiUrl('view_discounts/' + subscriptionId),
          type: 'get',
          data: credentials,
          success: function(response) {
            var codeMatch = /<input id="current_discount" type="text" value="([^"]*?)"/.exec(response);
            var detailMatch = /"code_details">\s*([^<]*?)\s*</.exec(response);
            discount = codeMatch ? {
              code: codeMatch[1],
              detail: detailMatch ? detailMatch[1] : ''
            } : undefined;
            next();
          },
          error: ajaxError(next)
        });
      },
    ], function(err) {
      cb(err, discount);
    });
  }

  function setDiscountCode(subscriptionId, discountCode, cb) {
    var data;
    async('setting discount code', [
      function(next) {
        getBoldCredentials(function(err, credentials) {
          data = credentials;
          next(err);
        });
      },
      function(next) {
        data.discount_code = discountCode; //eslint-disable-line camelcase
        $.ajax({
          url: apiUrl('save_discount_code/' + subscriptionId),
          type: 'get',
          data: data,
          success: function(response) {
            if (response && response.success === false) {
              return next(taskError(response.message));
            }
            next();
          },
          error: ajaxError(next)
        });
      },
    ], function(err) {
      cb(err);
    });
  }

  function getSubscriptionInfoAndDiscount(subscriptionId, cb) {
    var gotProducts = false;
    var gotDiscount = false;
    var products;
    var discount;
    function callback(err) {
      if (!cb) return;
      var result;
      if (!err) {
        if (!gotProducts || !gotDiscount) return;
        result = $.extend({}, { products: products }, { discount: discount });
      }
      cb(err, result);
      cb = null;
    }
    getSubscriptionInfo(subscriptionId, function(err, _info) {
      products = _info;
      gotProducts = !err;
      callback(err);
    });
    getDiscountCode(subscriptionId, function(err, _code) {
      discount = _code;
      gotDiscount = !err;
      callback(err);
    });
  }

  function getAllSubscriptionInfo(cb) {
    withTask('getting subscriptions', function() {
      getSubscriptions(function(err, subscriptions) {
        if (err) return cb(err);
        var ids = Object.keys(subscriptions);
        mapSerial(ids, getSubscriptionInfoAndDiscount, function(err, subscriptionInfos) {
          if (err) return cb(err);
          var fullSubscriptions = {};
          ids.forEach(function(id, ix) {
            fullSubscriptions[id] = $.extend({ id: id }, subscriptions[id], subscriptionInfos[ix]);
            fullSubscriptions[id].products.forEach(function(product) {
              var info = skuInfo(product.sku);
              if (!info) return;
              Object.keys(info).forEach(function(key) {
                if (key !== 'sku') {
                  product[key] = info[key];
                }
              });
            });
          });
          cb(null, fullSubscriptions);
        });
      });
    });
  }

  var productsBySku = {};
  function productFromSku(sku, cb) {
    withTask('getting product info', function() {
      sku = String(sku).toLowerCase();

      if (productsBySku[sku]) return cb(null, productsBySku[sku]);
      $.ajax({
        url: 'https://' + host + '/products/ifit-nourish-' + sku.substr(3) + '?view=nourish-json',
        dataType: 'text', //If this is json, the template will not be used
        success: function(response) {
          var prod = JSON.parse(response);
          var ro = prod.ro;
          var product = prod.product;
          product.supplement_facts = prod.supplement_facts; // eslint-disable-line camelcase

          if (ro) {
            product.variants.forEach(function(variant, ix) {
              variant.ro_lookup = ro[ix]; // eslint-disable-line camelcase
            });
          }
          productsBySku[sku] = product;
          return cb(null, product);
        },
        error: ajaxError(cb, 'getting product info')
      });
    });
  }

  function variantFromSku(sku, cb) {
    sku = String(sku).toLowerCase();
    productFromSku(sku, function(err, product) {
      if (err) return cb(err);
      var variant = product.variants[0];
      variant.product = product;
      if (!variant || String(variant.sku).toLowerCase() !== sku) return cb(taskError('Incorrect product variant'));
      cb(null, variant);
    });
  }

  function swapProduct(subscription, originalSku, replacementSku, cb) {
    replacementSku = replacementSku.replace(/[IRT]?$/i, 'R');
    var BOLD = checkBold(cb);
    if (!BOLD) return;

    var replacement;
    var found;
    var credentials;

    async('swapping your products', [
      function(next) {
        if (!subscription) {
          getSubscriptions(function(err, subscriptions) {
            if (err) return cb(err);
            var subscriptionIds = Object.keys(subscriptions);
            if (!subscriptionIds.length) {
              return next(taskError('No subscription found'));
            }
            if (subscriptionIds.length > 1) {
              return next(taskError('Multiple subscriptions found'));
            }
            subscription = subscriptionIds[0];
            next();
          });
        } else {
          next();
        }
      },
      function(next) {
        variantFromSku(replacementSku, function(err, variant) {
          replacement = variant;
          next(err);
        });
      },
      function(next) {
        getSubscriptionInfo(subscription, function(err, products) {
          if (err) return next(err);
          if (!products.length) return next(taskError('No product to replace'));

          if (originalSku) {
            originalSku = originalSku.toUpperCase();
            found = products.filter(function(product) {
              return product.sku.toUpperCase() === originalSku;
            })[0];
            if (!found) return cb(taskError('Product with SKU ' + originalSku + ' not found'));
          } else {
            if (products.length !== 1) return cb(taskError('Indeterminate product swap'));
            found = products[0];
          }
          next();
        });
      },
      function(next) {
        getBoldCredentials(function(err, _credentials) {
          credentials = _credentials;
          next(err);
        });
      },
      function(next) {
        var data = credentials;

        /* eslint-disable camelcase */
        data.product_id = replacement.product.id;
        data.variant_id = replacement.id;
        data.group_id = replacement.ro_lookup.group_id;
        data.product_internal_id = found.internalProductId;
        data.csrf_bold_token = BOLD.recurring_orders.csrf_token;
        /* eslint-enable camelcase */

        $.ajax({
          url: apiUrl('save_swap_product'),
          data: data,
          type: 'post',
          success: function() {
            next();
          },
          error: ajaxError(next, null, [302])
        });
      }
    ], function(err) {
      if (err) return cb(err);
      cb(null, replacement);
    });
  }

  function getSubscribeSetupData(variant, cb) {
    var BOLD = checkBold(cb);
    if (!BOLD) return;

    var result;
    async('subscribing', [
      function(next) {
        if (typeof variant === 'string') {
          variantFromSku(variant, function(err, _variant) {
            variant = _variant;
            next(err);
          });
        } else {
          next();
        }
      },
      function(next) {
        var data = {
          /* eslint-disable camelcase */
          shop_url: longHost,
          group_id: variant.ro_lookup.group_id,
          customer_id: (BOLD.customer && BOLD.customer.id) || '',
          product_id: variant.product.id,
          variant_id: variant.id,
          v: 2,
          _: Date.now()
          /* eslint-enable camelcase */
        };

        var url = makeGetUrl('https://ro.boldapps.net/recurring_settings/generate_rp', data);
        var catcher = dataCatcher();

        var timeout = setTimeout(function() {
          next(taskError('Error loading subscribe info', 'subscribing'));
          next = function() {};
        }, 10000);

        BOLD.helpers.loadScript(url, function() {
          clearTimeout(timeout);
          var keys = ['discounted_price', 'ro_discount_percentage', 'ro_unformatted_price'];
          result = {};
          var err = null;
          keys.forEach(function(key) {
            var field = catcher.find('.' + key);
            if (!field.length && !err) {
              err = taskError('Field ' + field + 'not found');
            }
            result[key] = field.val();
          });
          result.csrf_bold_token = BOLD.recurring_orders.csrf_token; //eslint-disable-line camelcase
          next();
        });

        function dataCatcher() {
          var form = $('#customButton').closest('form');
          if (!form.length) {
            form = $('<form><div id="customButton" style="display:none"></form></div>');
            $('body').append(form);
          }
          return form;
        }
      }
    ], function(err) {
      cb(err, result);
    });
  }

  function getGroupInfo(groupId, cb) {
    $.ajax({
      url: 'https://ro.boldapps.net/api_public/group/' + groupId + '?shop_url=' + longHost,
      type: 'get',
      dataType: 'json',
      success: function(response) {
        cb(null, response);
      },
      error: ajaxError(cb, 'getting subscription type info')
    });
  }

  function fetchSupplementFacts(sku, cb) {
    productFromSku(sku.replace(/[ir]?$/i, 'i'), function(err, res) {
      if (err) return cb(err);

      cb(null, res.supplement_facts);
    });
  }

  function addSubscriptionToCart(sku, kind, firstName, lastName, cb) {
    var BOLD = checkBold(cb);
    if (!BOLD) return;

    var variant;
    var setupData;
    var groupInfo;
    var data;
    var response;
    var trailer = {
      recurring: 'r',
      initial: 'i',
      trial: 't'
    }[kind.toLowerCase()];
    var convertible = trailer !== 'r';
    if (!trailer) {
      return cb(taskError('Incorrect parameter for subscription kind', 'adding a subscription to your cart'));
    }
    async('adding a subscription to your cart', [
      function(next) {
        variantFromSku(sku.replace(/[irt]?$/i, trailer), function(err, _variant) {
          variant = _variant;
          next(err);
        });
      },
      function(next) {
        if (convertible) {
          getGroupInfo(variant.ro_lookup.group_id, function(err, info) {
            groupInfo = info;
            next(err);
          });
        } else {
          getSubscribeSetupData(variant, function(err, _setupData) {
            setupData = _setupData;
            next(err);
          });
        }
      },
      function() {
        if (convertible) {
          var discountedPrice = variant.price * groupInfo.discount_percentage;
          /* eslint-disable camelcase */
          data = {
            id: variant.id,
            'bold-ro__selector_radio_button': 2,
            properties: {
              frequency_num: 1,
              frequency_type: 3,
              frequency_type_text: 'Month(s)',
              group_id: variant.ro_lookup.group_id,
              discounted_price: '$' + discountedPrice.toFixed(2),
              _ro_discount_percentage: groupInfo.group_discount,
              _ro_unformatted_price: discountedPrice,
              custFirstName: firstName,
              custLastName: lastName
            },
            csrf_bold_token: groupInfo.csrf_token,
            quantity: 1
          };
        } else {
          data = {
            id: variant.id,
            recurring_radio_btn: 2,
            frequency_num: 1,
            frequency_type: 3,
            group_id: variant.ro_lookup.group_id,
            properties: {
              frequency_num: 1,
              frequency_type: 3,
              frequency_type_text: 'Month(s)',
              group_id: variant.ro_lookup.group_id,
              discounted_price: setupData.discounted_price,
              _ro_discount_percentage: setupData.ro_discount_percentage,
              _ro_unformatted_price: setupData.ro_unformatted_price,
              custFirstName: firstName,
              custLastName: lastName
            },
            csrf_bold_token: setupData.csrf_bold_token,
            quantity: 1,
            quantities: [1],
            product_id: [variant.product.id],
            variant_id: [variant.id],
            note: ''
          };
          /* eslint-enable camelcase */
        }
      },
      function(next) {
        $.ajax({
          url: 'https://' + host + '/cart/add.js',
          type: 'post',
          data: flattenAPIObject(data, true),
          dataType: 'json',
          success: function(_response) {
            response = _response;
            next();
          },
          error: ajaxError(cb)
        });
      }
    ], function(err) {
      cb(err, response);
    });
  }

  function updateCart(updates, cb) {
    $.ajax({
      type: 'POST',
      url: '/cart/update.js',
      data: updates,
      dataType: 'json',
      success: function(response) {
        cb(null, response);
      },
      error: ajaxError(cb, 'updating your cart')
    });
  }

  function clearCart(cb) {
    $.ajax({
      type: 'POST',
      url: '/cart/clear.js',
      dataType: 'json',
      success: function(response) {
        cb(null, response);
      },
      error: ajaxError(cb, 'clearing your cart')
    });
  }

  function getCart(cb) {
    $.ajax({
      type: 'get',
      url: '/cart.js',
      dataType: 'json',
      success: function(response) {
        cb(null, response);
      },
      error: ajaxError(cb, 'getting your cart')
    });
  }

  function loginAndRedirect(url, maxMinutes) {
    var key = 'login_redirect';
    if (window.localStorage) {
      window.localStorage[key] = JSON.stringify({
        validUntil: Date.now() + (maxMinutes || 30) * 60e3,
        url: url
      });
    }
    window.location = '/account/login';
  }

  function decodeQuery(url, translate) {
    if (!url) {
      url = window.location.href;
    }
    var search = url.split('?')[1];
    var pairs = search && search.split('&');
    var params = {};
    if (pairs && pairs[0]) {
      pairs.forEach(function(pair) {
        var isNull = false;
        var ix = pair.indexOf('=');
        if (ix === -1) {
          ix = pair.length;
          isNull = true;
        }
        var key = decodeURIComponent(pair.substr(0, ix));
        if (translate || typeof translate === 'undefined') {
          key = key.replace(/[-_](.)/g, function(_, letter) {
            return letter.toUpperCase();
          });
        }
        params[key] = isNull ? null : decodeURIComponent(pair.substr(ix + 1));
      });
    }
    return params;
  }

  function snakeCase(str) {
    return str.replace(/[A-Z]/g, function(l) { return '_' + l.toLowerCase(); });
  }

  function snakeCaseObj(obj) {
    if (!obj || typeof obj !== 'object') return obj;
    var result = (obj instanceof Array) ? [] : {};
    Object.keys(obj).forEach(function(key) {
      var snakedKey = snakeCase(key);
      result[snakedKey] = snakeCaseObj(obj[key]);
    });
    return result;
  }

  function flattenAPIObject(data, collapseArrayIndices, base, result) {
    result = result || {};
    base = base || '';
    var pre = base ? base + '[' : '';
    var post = base ? ']' : '';
    var collapseIndices = Boolean(collapseArrayIndices && base);
    if (data.constructor !== Array || data.length > 1) {
      collapseIndices = false;
    }
    Object.keys(data).forEach(function(key) {
      var value = data[key];
      var targetKey = collapseIndices ? '' : key;
      var keyName = pre + targetKey + post;
      if (value && typeof value === 'object') {
        flattenAPIObject(value, collapseArrayIndices, keyName, result);
      } else {
        result[keyName] = value;
      }
    });
    return result;
  }

  function makeGetUrl(url, data) {
    var urlQuery = decodeQuery(url, false);
    url = url.split('?')[0];
    data = $.extend({}, urlQuery, data);
    if (!Object.keys(data).length) return url;
    return url + '?' + urlify(data);

    function urlify(data) {
      data = flattenAPIObject(data);
      var fields = [];
      Object.keys(data).forEach(function(key) {
        fields.push(encodeURIComponent(key) + '=' + encodeURIComponent(data[key]));
      });
      return fields.join('&');
    }
  }

  function getBoldManagementUrl(cb) {
    getBoldCredentials(function(err, creds) {
      if (err) return cb(err);
      /* eslint-disable camelcase */
      cb(
        null,
        apiUrl('recurring_orders', true, {
          bold_token: creds.bold_token,
          bold_signature: creds.bold_signature
        })
      );
      /* eslint-enable camelcase */
    });
  }

  function cancelSubscription(id, cb) {
    withTask('canceling your subscription', function() {
      getBoldCredentials(function(err, credentials) {
        if (err) return cb(err);
        /*eslint-disable camelcase */
        var data = {
          id: id,
          cancel_reason: '',
          bold_token: credentials.bold_token,
          bold_signature: credentials.bold_signature,
        };
        /*eslint-enable camelcase */

        $.ajax({
          url: apiUrl('delete_order'),
          type: 'post',
          data: data,
          cache: false,
          success: notifyIfit,
          error: ajaxError(cb, [302])
        });
      });

      function notifyIfit() {
        var time = (new Date()).getTime();
        var id = BOLD.customer.id;
        var email = BOLD.customer.email;
        var hash = sha256(String(time) + email + String(id));
        $.ajax({
          url: backend + '/shopify/cancel_subscription',
          type: 'post',
          contentType: 'application/json; charset=utf-8',
          processData: false,
          data: JSON.stringify({
            id: id,
            time: time,
            hash: hash,
          }),
          success: function(response) {
            cb(null, response);
          },
          error: ajaxError(cb)
        });
      }
    });
  }

  function logCancellation(info, cb) {
    withTask('logging reasons for cancellation', function() {
      $.ajax({
        url: backend + '/shopify/log_cancellation',
        type: 'post',
        contentType: 'application/json; charset=utf-8',
        processData: false,
        data: JSON.stringify(info),
        success: function(response) {
          cb(null, response);
        },
        error: ajaxError(cb)
      });
    });
  }

  function getShopifyAddresses(cb) {
    withTask('getting your addresses', function() {
      $.ajax({
        url: 'https://' + host + '/account/addresses?view=json',
        dataType: 'text', //If this is json, the template will not be used
        success: function(response) {
          try {
            cb(null, JSON.parse(response));
          } catch (err) {
            cb(taskError('Error parsing server response'));
          }
        },
        error: ajaxError(cb)
      });
    });
  }

  function addSetShopifyAddress(id, address, defaultAddress, cb) {
    if (typeof defaultAddress === 'function') {
      cb = defaultAddress;
      defaultAddress = undefined;
    }
    if (defaultAddress === undefined) {
      defaultAddress = address.default;
    }
    address = $.extend({}, address);
    if ('street1' in address) {
      if (!address.address1) {
        address.address1 = address.street1;
      }
      delete address.street1;
    }
    if ('street2' in address) {
      if (!address.address2) {
        address.address2 = address.street2;
      }
      delete address.street2;
    }

    address.country = codeToCountry(address.country);
    address.province = codeToState(address.province);

    var data = {
      formType: 'customer_address',
      address: address,
      utf8: '✓'
    };
    if (id) {
      data._method = 'put';
    }
    if (defaultAddress === undefined) {
      defaultAddress = data.address.default;
    }
    if (defaultAddress !== undefined) {
      data.address.default = Number(Boolean(defaultAddress));
    }
    $.ajax({
      url: 'https://' + host + '/account/addresses' + (id ? '/' + id : ''),
      method: 'post',
      data: flattenAPIObject(snakeCaseObj(data)),
      success: function(data) {
        cb();
      },
      error: ajaxError(cb, 'storing your address')
    });
  }

  function addShopifyAddress(address, defaultAddress, cb) {
    addSetShopifyAddress(null, address, defaultAddress, cb);
  }

  function setShopifyAddress(id, address, defaultAddress, cb) {
    addSetShopifyAddress(id, address, defaultAddress, cb);
  }

  function deleteShopifyAddress(id, cb) {
    $.ajax({
      url: 'https://' + host + '/account/addresses/' + id,
      method: 'post',
      data: { _method: 'delete' },
      success: function(data) {
        cb();
      },
      error: ajaxError(cb, 'deleting your address')
    });
  }

  function setShippingBilling(subscriptionId, oldShipping, newShipping, oldBilling, newBilling, cb) {
    async('changing your address', true, [
      function setBoldAddresses(next) {
        var credentials;
        async([
          function getCredentials(next) {
            if (!subscriptionId) return next();
            getBoldCredentials(function(err, _credentials) {
              if (err) return next(err);
              credentials = _credentials;
              next();
            });
          },
          function setAddresses(next) {
            if (!subscriptionId) return next();
            /*eslint-disable camelcase */
            var data = {
              bold_token: credentials.bold_token,
              bold_signature: credentials.bold_signature,
              csrf_bold_token: BOLD.recurring_orders.csrf_token,
              first_name: newShipping.firstName,
              last_name: newShipping.lastName,
              address1: newShipping.street1,
              address2: newShipping.street2,
              country: newShipping.country,
              province: newShipping.province,
              city: newShipping.city,
              zip: newShipping.zip,
              phone: '',
              billing_first_name: newBilling.firstName,
              billing_last_name: newBilling.lastName,
              billing_address1: newBilling.street1,
              billing_address2: newBilling.street2,
              billing_country: newBilling.country,
              billing_province: newBilling.province,
              billing_city: newBilling.city,
              billing_zip: newBilling.zip,
              billing_phone: ''
            };
            /*eslint-enable camelcase */

            $.ajax({
              url: apiUrl('save_address', {
                id: subscriptionId,
                shop: shop
              }),
              type: 'post',
              data: data,
              cache: false,
              success: function() {
                next();
              },
              error: ajaxError(next, null, [302])
            });
          }
        ], next);
      },
      function setShopifyAddresses(next) {
        var addresses;
        var shopifyShipping;
        var shopifyBilling;
        var userShippingBilling;
        var oldShopifyShipping;
        var oldShopifyBilling;
        async([
          function getAddresses(next) {
            getShopifyAddresses(function(err, _addresses) {
              if (err) return next(err);
              addresses = _addresses;
              next();
            });
          },
          function getUserShippingBilling(next) {
            getCustomerField('addresses', true, function(err, data) {
              userShippingBilling = data;
              next(err);
            });
          },
          function findPreviousShopifyAddresses() {
            oldShopifyShipping = oldShipping;
            oldShopifyBilling = oldBilling;
            if (userShippingBilling) {
              if (userShippingBilling.shipping) {
                oldShopifyShipping = userShippingBilling.shipping;
              }
              if (userShippingBilling.billing) {
                oldShopifyBilling = userShippingBilling.billing;
              }
            }
          },
          function findAddresses() {
            addresses.forEach(function(address) {
              if (compareAddresses(oldShopifyShipping, address) && !compareAddresses(oldShopifyShipping, newShipping)) {
                shopifyShipping = address;
              }
              if (compareAddresses(oldShopifyBilling, address) && !compareAddresses(oldShopifyBilling, newBilling)) {
                shopifyBilling = address;
              }
            });
          },
          function setShipping(next) {
            if (addresses.some(compareAddresses.bind(null, newShipping))) return next(); //Already have the new one
            if (isEmptyAddress(newShipping)) return next();
            if (!shopifyShipping) {
              addShopifyAddress(newShipping, next);
            } else {
              setShopifyAddress(shopifyShipping.id, newShipping, next);
            }
          },
          function setBilling(next) {
            if (addresses.some(compareAddresses.bind(null, newBilling))) return next(); //Already have the new one
            if (isEmptyAddress(newBilling)) return next();
            if (!shopifyBilling) {
              addShopifyAddress(newBilling, true, next);
            } else {
              setShopifyAddress(shopifyBilling.id, newBilling, next);
            }
          },
          function setUserShippingBilling(next) {
            setCustomerField('addresses', {
              shipping: newShipping,
              billing: newBilling
            }, true, next);
          }
        ], next);
      }
    ], cb);
  }

  function isEmptyAddress(address) {
    if (['firstName', 'lastName', 'company', 'street1', 'street2', 'city', 'zip', 'province'].some(function(key) {
      return address[key];
    })) return false;
    return (!address.country || address.country.toUpperCase() === 'US' || countryToCode(address.country) === 'US');
  }

  function compareAddresses(a, b) {
    return (Boolean(a && b) && !['firstName', 'lastName', 'company', 'street1', 'street2', 'city', 'zip', 'province', 'country'].some(function(key) {
      var canonicalize;
      if (key === 'province') {
        canonicalize = stateToCode;
      } else if (key === 'country') {
        canonicalize = countryToCode;
      }
      var streetMatch = /^street(\d)/.exec(key);
      var aKey = key;
      var bKey = key;
      if (streetMatch) {
        var addressKey = 'address' + streetMatch[1];
        if (!(key in a) && addressKey in a) {
          aKey = addressKey;
        }
        if (!(key in b) && addressKey in b) {
          bKey = addressKey;
        }
      }
      var snakedKey = snakeCase(key);
      if (!(key in a) && snakedKey in a) {
        aKey = snakedKey;
      }
      if (!(key in b) && snakedKey in b) {
        bKey = snakedKey;
      }
      var aValue = a[aKey] || '';
      var bValue = b[bKey] || '';
      if (canonicalize) {
        aValue = canonicalize(aValue);
        bValue = canonicalize(bValue);
      }
      return aValue.toLowerCase() !== bValue.toLowerCase();
    }));
  }

  function setPaymentMethod(subscriptionId, stripeToken, cb) {
    withTask('setting your payment method', function() {
      var credentials;
      async([
        function(next) {
          getBoldCredentials(function(err, creds) {
            credentials = creds;
            next(err);
          });
        },
        function(next) {
          /* eslint-disable camelcase */
          var data = {
            bold_token: credentials.bold_token,
            bold_signature: credentials.bold_signature,
            csrf_bold_token: BOLD.recurring_orders.csrf_token,
            customer_email: BOLD.customer.email,
            payment_method_token: '',
            stripeToken: stripeToken
          };
          /* eslint-enable camelcase */
          $.ajax({
            url: apiUrl('update_customer', true, { id: subscriptionId }),
            type: 'post',
            dataType: 'text',
            data: data,
            success: function(data) {
              var result;
              try {
                result = JSON.parse(data);
              } catch (err) {
                return next(err);
              }
              if (result.status) return next();
              next(taskError(result.message));
            },
            error: ajaxError(next, [302])
          });
        }
      ], cb);
    });
  }

  function dateToStr(date) {
    if (date.toLocaleDateString) {
      return date.toLocaleDateString(undefined, { year: 'numeric', month: 'short', day: 'numeric' });
    }

    var months = [
      'Jan',
      'Feb',
      'Mar',
      'Apr',
      'May',
      'Jun',
      'Jul',
      'Aug',
      'Sep',
      'Oct',
      'Nov',
      'Dec'
    ];
    return months[date.getMonth()] + ' ' + date.getDate() + ', ' + date.getFullYear();
  }

  /**
   * @param {string} name
   * @param {mixed} value
   * @param {boolean} [isJson]
   * @param {function} cb
   */
  function setCustomerField(name, value, isJson, cb) {
    withTask('storing customer info', function() {
      if (typeof isJson === 'function') {
        cb = isJson;
        isJson = false;
      }
      if (!isLoggedIn()) return cb(taskError('Customer not logged in'));
      if (typeof value === 'object') {
        isJson = true;
      }
      if (isJson) {
        try {
          value = JSON.stringify(value);
        } catch (err) {
          return cb(err);
        }
      }
      var time = (new Date()).getTime();
      var id = BOLD.customer.id;
      var email = BOLD.customer.email;
      var hash = sha256(String(time) + email + String(id));
      $.ajax({
        url: backend + '/shopify/set_customer_meta',
        type: 'post',
        contentType: 'application/json; charset=utf-8',
        processData: false,
        data: JSON.stringify({
          id: id,
          time: time,
          hash: hash,
          name: name,
          value: value,
        }),
        success: function(response) {
          cb(null, response);
        },
        error: ajaxError(cb)
      });
    });
  }

  function getCustomerFields(cb) {
    withTask('loading form data', function() {
      if (!isLoggedIn()) return cb(taskError('Customer not logged in'));
      $.ajax({
        url: 'https://' + host + '/pages/get-customer-data',
        dataType: 'text',
        success: function(response) {
          if (response.trim().length) {
            cb(null, JSON.parse(response.trim()));
            return;
          }
          cb(null, {});
        },
        error: ajaxError(cb)
      });
    });
  }

  function getLatestOrder(cb) {
    withTask('loading order data', function() {
      if (!isLoggedIn()) return cb(taskError('Customer not logged in'));
      $.ajax({
        url: 'https://' + host + '/pages/latest-order',
        dataType: 'text',
        success: function(response) {
          if (response.trim().length) {
            cb(null, JSON.parse(response.trim()));
            return;
          }
          cb(null, null);
        },
        error: ajaxError(cb)
      });
    });
  }

  /**
   * @param {string} name
   * @param {boolean} [isJson]
   * @param {function} cb
   */
  function getCustomerField(name, isJson, cb) {
    if (typeof isJson === 'function') {
      cb = isJson;
      isJson = false;
    }
    getCustomerFields(function(err, fields) {
      if (err) return cb(err);
      var value = (fields || {})[name];
      if (isJson && value !== undefined) {
        try {
          value = JSON.parse(value);
        } catch (err) {
          return cb(err);
        }
      }
      cb(null, value);
    });
  }

  function loadFormData(cb) {
    getCustomerField('formData', true, cb);
  }

  function changePassword(oldPass, newPass, repeatPass, cb) {
    withTask('changing your password', function() {
      if (!isLoggedIn()) return cb(taskError('Customer not logged in'));

      $.ajax({
        url: backend + '/shopify/change_password',
        type: 'post',
        contentType: 'application/json; charset=utf-8',
        processData: false,
        /* eslint-disable camelcase */
        data: JSON.stringify({
          customer_id: BOLD.customer.id,
          old_password: oldPass,
          new_password: newPass,
          repeat_password: repeatPass
        }),
        /* eslint-enable camelcase */
        success: function(response) {
          if (!response.success) {
            var message = 'There was a problem';
            if (response.error) {
              message = response.error;
            }
            return cb(taskError(message));
          }
          cb();
        },
        error: ajaxError(cb)
      });
    });
  }

  function changeEmail(curPass, newEmail, cb) {
    withTask('changing your email', function() {
      if (!isLoggedIn()) return cb(taskError('Customer not logged in'));

      $.ajax({
        url: backend + '/shopify/change_email',
        type: 'post',
        contentType: 'application/json; charset=utf-8',
        processData: false,
        /* eslint-disable camelcase */
        data: JSON.stringify({
          customer_id: BOLD.customer.id,
          current_password: curPass,
          new_email: newEmail
        }),
        /* eslint-enable camelcase */
        success: function(response) {
          if (!response.success) {
            var message = 'There was a problem';
            if (response.error) {
              message = response.error;
            }
            return cb(taskError(message));
          }
          cb();
        },
        error: ajaxError(cb)
      });
    });
  }

  function validateEmail(email, cb) {
    withTask('validating your email', function() {
      if (!isLoggedIn()) return cb(taskError('Customer not logged in'));

      $.ajax({
        url: backend + '/shopify/validate_email',
        type: 'post',
        contentType: 'application/json; charset=utf-8',
        processData: false,
        /* eslint-disable camelcase */
        data: JSON.stringify({
          email: email
        }),
        /* eslint-enable camelcase */
        success: function(response) {
          if (!response.success) {
            var message = 'There was a problem';
            if (response.error) {
              message = response.error;
            }
            return cb(taskError(message));
          }
          cb(null, response.valid);
        },
        error: ajaxError(cb)
      });
    });
  }

  function getBoldDiscountInfo(csrfToken, discountCode, cart, shippingFee, country, cb) {
    withTask('validating your discount code', function() {
      $.ajax({
        url: backend + '/shopify/bold_get_discount_info',
        type: 'post',
        contentType: 'application/json; charset=utf-8',
        processData: true,
        data: JSON.stringify({
          cart: cart,
          csrfToken: csrfToken,
          discountCode: discountCode,
          shippingFee: shippingFee,
          country: country
        }),
        success: function(response) {
          if (!response.success) {
            return cb(taskError(response.message || response.error));
          }
          cb(null, response);
        },
        error: ajaxError(cb)
      });
    });
  }

  function boldGetShippingMethods(shippingAddress, cb) {
    withTask('fetching shipping rates', function() {
      $.ajax({
        url: backend + '/shopify/bold_get_shipping_methods',
        type: 'post',
        contentType: 'application/json; charset=utf-8',
        processData: true,
        data: JSON.stringify({
          shipping: shippingAddress,
          cartToken: BOLD.rawCart.token
        }),
        success: function(response) {
          if (!response.success) {
            return cb(taskError(response.message || response.error));
          }
          cb(null, response.methods);
        },
        error: ajaxError(cb)
      });
    });
  }

  function validateAddress(address, checkDupes, cb) {
    withTask('validating your address', function() {
      var data = $.extend({}, address, {
        checkDupes: Boolean(checkDupes)
      });
      $.ajax({
        url: backend + '/shopify/validate_address',
        type: 'post',
        contentType: 'application/json; charset=utf-8',
        processData: true,
        data: JSON.stringify(data),
        success: function(response) {
          if (!response.success) {
            return cb(taskError(response.message || response.error));
          }
          cb(null, response);
        },
        error: ajaxError(cb)
      });
    });
  }

  var taxCache = {};

  function boldCalculateTax(csrfToken, shippingAddress, shippingFee, subtotalTaxable, subtotalAll, taxUrl, cart, taxIncluded, taxShipping, cb) {
    withTask('calculating your taxes', function() {
      if (!isLoggedIn()) {
        return cb(taskError('Not logged in'));
      }
      var data = {
        shippingAddress: shippingAddress,
        email: BOLD.customer.email,
        shippingFee: shippingFee,
        subtotalTaxable: subtotalTaxable,
        subtotalAll: subtotalAll,
        taxUrl: taxUrl,
        cart: cart,
        taxIncluded: taxIncluded,
        taxShipping: taxShipping
      };
      var cacheKey = JSON.stringify(data);
      if (taxCache[cacheKey] !== undefined) {
        return cb(null, taxCache[cacheKey]);
      }
      data.csrfToken = csrfToken;
      $.ajax({
        url: backend + '/shopify/bold_calculate_tax',
        type: 'post',
        contentType: 'application/json; charset=utf-8',
        processData: true,
        data: JSON.stringify(data),
        success: function(response) {
          if (!response.success) {
            return cb(taskError(response.message || response.error));
          }
          taxCache[cacheKey] = response.tax;
          cb(null, response.tax);
        },
        error: ajaxError(cb)
      });
    });
  }

  function getBoldCheckoutPage(cart, cb) {
    withTask('accessing checkout information', function() {
      if (!isLoggedIn()) return cb(taskError('You must be logged in'));
      $.ajax({
        url: backend + '/shopify/bold_checkout_page',
        type: 'post',
        contentType: 'application/json; charset=utf-8',
        processData: true,
        data: JSON.stringify({
          cart: cart,
          customerId: BOLD.customer.id,
          csrfToken: BOLD.recurring_orders.csrf_token
        }),
        success: function(response) {
          if (!response.success) {
            return cb(taskError(response.message || response.error));
          }
          cb(null, response);
        },
        error: ajaxError(cb)
      });
    });
  }

  function boldCheckout(csrfToken, shippingAddress, billingAddress, shippingMethod, taxIncluded, taxShipping, discountCode, stripeToken, cb) {
    withTask('placing your purchase', function() {
      $.ajax({
        url: backend + '/shopify/bold_checkout',
        type: 'post',
        contentType: 'application/json; charset=utf-8',
        processData: true,
        data: JSON.stringify({
          shipping: shippingAddress,
          billing: billingAddress,
          stripeToken: stripeToken,
          shippingMethod: shippingMethod,
          customerId: BOLD.customer.id,
          email: BOLD.customer.email,
          taxIncluded: taxIncluded,
          taxShipping: taxShipping,
          discountCode: discountCode,
          csrfToken: csrfToken,
          shippingId: 0,
          cartToken: BOLD.rawCart.token
        }),
        success: function(response) {
          if (!response.success) {
            return cb(taskError(response.message || response.error));
          }
          cb(null, response);
        },
        error: ajaxError(cb)
      });
    });
  }

  var countries = {
    US: 'United States',
    AS: 'American Samoa',
    AD: 'Andorra',
    AR: 'Argentina',
    AU: 'Australia',
    AT: 'Austria',
    BD: 'Bangladesh',
    BE: 'Belgium',
    BR: 'Brazil',
    BG: 'Bulgaria',
    CA: 'Canada',
    CN: 'China',
    HR: 'Croatia',
    CZ: 'Czech Republic',
    DK: 'Denmark',
    DO: 'Dominican Republic',
    FO: 'Faroe Islands',
    FI: 'Finland',
    FR: 'France',
    GF: 'French Guyana',
    RE: 'French Reunion',
    DE: 'Germany',
    GL: 'Greenland',
    GP: 'Guadeloupe',
    GU: 'Guam',
    GT: 'Guatemala',
    GG: 'Guernsey',
    GY: 'Guyana',
    HU: 'Hungary',
    IS: 'Iceland',
    IN: 'India',
    IM: 'Isle of Man',
    IT: 'Italy',
    JP: 'Japan',
    JE: 'Jersey',
    LI: 'Liechtenstein',
    LT: 'Lithuania',
    LU: 'Luxembourg',
    MK: 'Macedonia',
    MY: 'Malaysia',
    MH: 'Marshall Islands',
    MQ: 'Martinique',
    YT: 'Mayotte',
    MX: 'Mexico',
    MD: 'Moldavia',
    MC: 'Monaco',
    NL: 'Netherlands',
    NZ: 'New Zealand',
    MP: 'Northern Mariana Islands',
    NO: 'Norway',
    PK: 'Pakistan',
    PH: 'Phillippines',
    PL: 'Poland',
    PT: 'Portugal',
    PR: 'Puerto Rico',
    RU: 'Russia',
    PM: 'Saint Pierre and Miquelon',
    SM: 'San Marino',
    SK: 'Slovak Republic',
    SI: 'Slovenia',
    ZA: 'South Africa',
    ES: 'Spain',
    LK: 'Sri Lanka',
    SJ: 'Svalbard & Jan Mayen Islands',
    SE: 'Sweden',
    CH: 'Switzerland',
    TH: 'Thailand',
    TR: 'Turkey',
    GB: 'United Kingdom',
    VA: 'Vatican',
    VI: 'Virgin Islands'
  };

  function countryToCode(country) {
    var code;
    country = country.replace(/\s+/g, '').toUpperCase();
    var found = Object.keys(countries).some(function(countryCode) {
      if (countries[countryCode].replace(/\s+/g, '').toUpperCase() === country) {
        code = countryCode;
        return true;
      }
    });
    return found ? code : country;
  }

  function codeToCountry(code) {
    return code && countries[code.toUpperCase()] || code;
  }

  var states = {
    AK: 'Alaska',
    AL: 'Alabama',
    AR: 'Arkansas',
    AZ: 'Arizona',
    CA: 'California',
    CO: 'Colorado',
    CT: 'Connecticut',
    DC: 'District of Columbia',
    DE: 'Delaware',
    FL: 'Florida',
    GA: 'Georgia',
    HI: 'Hawaii',
    IA: 'Iowa',
    ID: 'Idaho',
    IL: 'Illinois',
    IN: 'Indiana',
    KS: 'Kansas',
    KY: 'Kentucky',
    LA: 'Louisiana',
    MA: 'Massachusetts',
    MD: 'Maryland',
    ME: 'Maine',
    MI: 'Michigan',
    MN: 'Minnesota',
    MO: 'Missouri',
    MS: 'Mississippi',
    MT: 'Montana',
    NC: 'North Carolina',
    ND: 'North Dakota',
    NE: 'Nebraska',
    NH: 'New Hampshire',
    NJ: 'New Jersey',
    NM: 'New Mexico',
    NV: 'Nevada',
    NY: 'New York',
    OH: 'Ohio',
    OK: 'Oklahoma',
    OR: 'Oregon',
    PA: 'Pennsylvania',
    RI: 'Rhode Island',
    SC: 'South Carolina',
    SD: 'South Dakota',
    TN: 'Tennessee',
    TX: 'Texas',
    UT: 'Utah',
    VA: 'Virginia',
    VT: 'Vermont',
    WA: 'Washington',
    WI: 'Wisconsin',
    WV: 'West Virginia',
    WY: 'Wyoming'
  };

  function stateToCode(name) {
    var code;
    name = name.replace(/\s+/g, '').toUpperCase();
    var found = Object.keys(states).some(function(stateCode) {
      if (states[stateCode].replace(/\s+/g, '').toUpperCase() === name) {
        code = stateCode;
        return true;
      }
    });
    return found ? code : name;
  }

  function codeToState(code) {
    return code && states[String(code).toUpperCase()] || code;
  }

  return {
    getBoldManagementUrl: getBoldManagementUrl,
    decodeQuery: decodeQuery,
    getSubscriptions: getSubscriptions,
    getSubscriptionInfo: getSubscriptionInfo,
    getDiscountCode: getDiscountCode,
    setDiscountCode: setDiscountCode,
    getAllSubscriptionInfo: getAllSubscriptionInfo,
    getShopifyAddresses: getShopifyAddresses,
    variantFromSku: variantFromSku,
    updateCart: updateCart,
    clearCart: clearCart,
    getCart: getCart,
    addSubscriptionToCart: addSubscriptionToCart,
    swapProduct: swapProduct,
    skipShipSubscriptionOrder: skipShipSubscriptionOrder,
    setNextOrderDate: setNextOrderDate,
    async: async,
    mapSerial: mapSerial,
    makeGetUrl: makeGetUrl,
    dateAsIso: dateAsIso,
    cancelSubscription: cancelSubscription,
    setShippingBilling: setShippingBilling,
    setPaymentMethod: setPaymentMethod,
    getCreditCardInfo: getCreditCardInfo,
    isLoggedIn: isLoggedIn,
    loginAndRedirect: loginAndRedirect,
    skuInfo: skuInfo,
    fetchSupplementFacts: fetchSupplementFacts,
    dateToStr: dateToStr,
    setCustomerField: setCustomerField,
    getCustomerField: getCustomerField,
    getLatestOrder: getLatestOrder,
    loadFormData: loadFormData,
    changePassword: changePassword,
    changeEmail: changeEmail,
    validateEmail: validateEmail,
    validateAddress: validateAddress,
    codeToCountry: codeToCountry,
    stateToCode: stateToCode,
    codeToState: codeToState,
    template: template,
    compareAddresses: compareAddresses,
    isEmptyAddress: isEmptyAddress,
    addShopifyAddress: addShopifyAddress,
    setShopifyAddress: setShopifyAddress,
    deleteShopifyAddress: deleteShopifyAddress,
    getBoldCheckoutPage: getBoldCheckoutPage,
    boldCheckout: boldCheckout,
    getBoldDiscountInfo: getBoldDiscountInfo,
    boldGetShippingMethods: boldGetShippingMethods,
    boldCalculateTax: boldCalculateTax,
    logCancellation: logCancellation,
    htmlEncode: htmlEncode,
    myShopifyDomain: longHost,
    isProduction: isProd
  };

  var sha256func;

  function sha256(message) {
    /* eslint-disable */
    if (!sha256func) {
      var module = { exports: {} };

      /**
       * [js-sha256]{@link https://github.com/emn178/js-sha256}
       *
       * @version 0.8.0
       * @author Chen, Yi-Cyuan [emn178@gmail.com]
       * @copyright Chen, Yi-Cyuan 2014-2017
       * @license MIT
       */
      !function(){"use strict";function t(t,i){i?(d[0]=d[16]=d[1]=d[2]=d[3]=d[4]=d[5]=d[6]=d[7]=d[8]=d[9]=d[10]=d[11]=d[12]=d[13]=d[14]=d[15]=0,this.blocks=d):this.blocks=[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],t?(this.h0=3238371032,this.h1=914150663,this.h2=812702999,this.h3=4144912697,this.h4=4290775857,this.h5=1750603025,this.h6=1694076839,this.h7=3204075428):(this.h0=1779033703,this.h1=3144134277,this.h2=1013904242,this.h3=2773480762,this.h4=1359893119,this.h5=2600822924,this.h6=528734635,this.h7=1541459225),this.block=this.start=this.bytes=this.hBytes=0,this.finalized=this.hashed=!1,this.first=!0,this.is224=t}function i(i,s,r){var e,n=typeof i;if("string"===n){var a,o=[],u=i.length,c=0;for(e=0;e<u;++e)(a=i.charCodeAt(e))<128?o[c++]=a:a<2048?(o[c++]=192|a>>6,o[c++]=128|63&a):a<55296||a>=57344?(o[c++]=224|a>>12,o[c++]=128|a>>6&63,o[c++]=128|63&a):(a=65536+((1023&a)<<10|1023&i.charCodeAt(++e)),o[c++]=240|a>>18,o[c++]=128|a>>12&63,o[c++]=128|a>>6&63,o[c++]=128|63&a);i=o}else{if("object"!==n)throw h;if(null===i)throw h;if(f&&i.constructor===ArrayBuffer)i=new Uint8Array(i);else if(!(Array.isArray(i)||f&&ArrayBuffer.isView(i)))throw h}i.length>64&&(i=new t(s,!0).update(i).array());var y=[],p=[];for(e=0;e<64;++e){var l=i[e]||0;y[e]=92^l,p[e]=54^l}t.call(this,s,r),this.update(p),this.oKeyPad=y,this.inner=!0,this.sharedMemory=r}var h="input is invalid type",s="object"==typeof window,r=s?window:{};r.JS_SHA256_NO_WINDOW&&(s=!1);var e=!s&&"object"==typeof self,n=!r.JS_SHA256_NO_NODE_JS&&"object"==typeof process&&process.versions&&process.versions.node;n?r=global:e&&(r=self);var a=!r.JS_SHA256_NO_COMMON_JS&&"object"==typeof module&&module.exports,o="function"==typeof define&&define.amd,f=!r.JS_SHA256_NO_ARRAY_BUFFER&&"undefined"!=typeof ArrayBuffer,u="0123456789abcdef".split(""),c=[-2147483648,8388608,32768,128],y=[24,16,8,0],p=[1116352408,1899447441,3049323471,3921009573,961987163,1508970993,2453635748,2870763221,3624381080,310598401,607225278,1426881987,1925078388,2162078206,2614888103,3248222580,3835390401,4022224774,264347078,604807628,770255983,1249150122,1555081692,1996064986,2554220882,2821834349,2952996808,3210313671,3336571891,3584528711,113926993,338241895,666307205,773529912,1294757372,1396182291,1695183700,1986661051,2177026350,2456956037,2730485921,2820302411,3259730800,3345764771,3516065817,3600352804,4094571909,275423344,430227734,506948616,659060556,883997877,958139571,1322822218,1537002063,1747873779,1955562222,2024104815,2227730452,2361852424,2428436474,2756734187,3204031479,3329325298],l=["hex","array","digest","arrayBuffer"],d=[];!r.JS_SHA256_NO_NODE_JS&&Array.isArray||(Array.isArray=function(t){return"[object Array]"===Object.prototype.toString.call(t)}),!f||!r.JS_SHA256_NO_ARRAY_BUFFER_IS_VIEW&&ArrayBuffer.isView||(ArrayBuffer.isView=function(t){return"object"==typeof t&&t.buffer&&t.buffer.constructor===ArrayBuffer});var A=function(i,h){return function(s){return new t(h,!0).update(s)[i]()}},b=function(i){var h=A("hex",i);n&&(h=v(h,i)),h.create=function(){return new t(i)},h.update=function(t){return h.create().update(t)};for(var s=0;s<l.length;++s){var r=l[s];h[r]=A(r,i)}return h},v=function(t,i){var s=eval("require('crypto')"),r=eval("require('buffer').Buffer"),e=i?"sha224":"sha256",n=function(i){if("string"==typeof i)return s.createHash(e).update(i,"utf8").digest("hex");if(null===i||void 0===i)throw h;return i.constructor===ArrayBuffer&&(i=new Uint8Array(i)),Array.isArray(i)||ArrayBuffer.isView(i)||i.constructor===r?s.createHash(e).update(new r(i)).digest("hex"):t(i)};return n},w=function(t,h){return function(s,r){return new i(s,h,!0).update(r)[t]()}},_=function(t){var h=w("hex",t);h.create=function(h){return new i(h,t)},h.update=function(t,i){return h.create(t).update(i)};for(var s=0;s<l.length;++s){var r=l[s];h[r]=w(r,t)}return h};t.prototype.update=function(t){if(!this.finalized){var i,s=typeof t;if("string"!==s){if("object"!==s)throw h;if(null===t)throw h;if(f&&t.constructor===ArrayBuffer)t=new Uint8Array(t);else if(!(Array.isArray(t)||f&&ArrayBuffer.isView(t)))throw h;i=!0}for(var r,e,n=0,a=t.length,o=this.blocks;n<a;){if(this.hashed&&(this.hashed=!1,o[0]=this.block,o[16]=o[1]=o[2]=o[3]=o[4]=o[5]=o[6]=o[7]=o[8]=o[9]=o[10]=o[11]=o[12]=o[13]=o[14]=o[15]=0),i)for(e=this.start;n<a&&e<64;++n)o[e>>2]|=t[n]<<y[3&e++];else for(e=this.start;n<a&&e<64;++n)(r=t.charCodeAt(n))<128?o[e>>2]|=r<<y[3&e++]:r<2048?(o[e>>2]|=(192|r>>6)<<y[3&e++],o[e>>2]|=(128|63&r)<<y[3&e++]):r<55296||r>=57344?(o[e>>2]|=(224|r>>12)<<y[3&e++],o[e>>2]|=(128|r>>6&63)<<y[3&e++],o[e>>2]|=(128|63&r)<<y[3&e++]):(r=65536+((1023&r)<<10|1023&t.charCodeAt(++n)),o[e>>2]|=(240|r>>18)<<y[3&e++],o[e>>2]|=(128|r>>12&63)<<y[3&e++],o[e>>2]|=(128|r>>6&63)<<y[3&e++],o[e>>2]|=(128|63&r)<<y[3&e++]);this.lastByteIndex=e,this.bytes+=e-this.start,e>=64?(this.block=o[16],this.start=e-64,this.hash(),this.hashed=!0):this.start=e}return this.bytes>4294967295&&(this.hBytes+=this.bytes/4294967296<<0,this.bytes=this.bytes%4294967296),this}},t.prototype.finalize=function(){if(!this.finalized){this.finalized=!0;var t=this.blocks,i=this.lastByteIndex;t[16]=this.block,t[i>>2]|=c[3&i],this.block=t[16],i>=56&&(this.hashed||this.hash(),t[0]=this.block,t[16]=t[1]=t[2]=t[3]=t[4]=t[5]=t[6]=t[7]=t[8]=t[9]=t[10]=t[11]=t[12]=t[13]=t[14]=t[15]=0),t[14]=this.hBytes<<3|this.bytes>>29,t[15]=this.bytes<<3,this.hash()}},t.prototype.hash=function(){var t,i,h,s,r,e,n,a,o,f=this.h0,u=this.h1,c=this.h2,y=this.h3,l=this.h4,d=this.h5,A=this.h6,b=this.h7,v=this.blocks;for(t=16;t<64;++t)i=((r=v[t-15])>>>7|r<<25)^(r>>>18|r<<14)^r>>>3,h=((r=v[t-2])>>>17|r<<15)^(r>>>19|r<<13)^r>>>10,v[t]=v[t-16]+i+v[t-7]+h<<0;for(o=u&c,t=0;t<64;t+=4)this.first?(this.is224?(e=300032,b=(r=v[0]-1413257819)-150054599<<0,y=r+24177077<<0):(e=704751109,b=(r=v[0]-210244248)-1521486534<<0,y=r+143694565<<0),this.first=!1):(i=(f>>>2|f<<30)^(f>>>13|f<<19)^(f>>>22|f<<10),s=(e=f&u)^f&c^o,b=y+(r=b+(h=(l>>>6|l<<26)^(l>>>11|l<<21)^(l>>>25|l<<7))+(l&d^~l&A)+p[t]+v[t])<<0,y=r+(i+s)<<0),i=(y>>>2|y<<30)^(y>>>13|y<<19)^(y>>>22|y<<10),s=(n=y&f)^y&u^e,A=c+(r=A+(h=(b>>>6|b<<26)^(b>>>11|b<<21)^(b>>>25|b<<7))+(b&l^~b&d)+p[t+1]+v[t+1])<<0,i=((c=r+(i+s)<<0)>>>2|c<<30)^(c>>>13|c<<19)^(c>>>22|c<<10),s=(a=c&y)^c&f^n,d=u+(r=d+(h=(A>>>6|A<<26)^(A>>>11|A<<21)^(A>>>25|A<<7))+(A&b^~A&l)+p[t+2]+v[t+2])<<0,i=((u=r+(i+s)<<0)>>>2|u<<30)^(u>>>13|u<<19)^(u>>>22|u<<10),s=(o=u&c)^u&y^a,l=f+(r=l+(h=(d>>>6|d<<26)^(d>>>11|d<<21)^(d>>>25|d<<7))+(d&A^~d&b)+p[t+3]+v[t+3])<<0,f=r+(i+s)<<0;this.h0=this.h0+f<<0,this.h1=this.h1+u<<0,this.h2=this.h2+c<<0,this.h3=this.h3+y<<0,this.h4=this.h4+l<<0,this.h5=this.h5+d<<0,this.h6=this.h6+A<<0,this.h7=this.h7+b<<0},t.prototype.hex=function(){this.finalize();var t=this.h0,i=this.h1,h=this.h2,s=this.h3,r=this.h4,e=this.h5,n=this.h6,a=this.h7,o=u[t>>28&15]+u[t>>24&15]+u[t>>20&15]+u[t>>16&15]+u[t>>12&15]+u[t>>8&15]+u[t>>4&15]+u[15&t]+u[i>>28&15]+u[i>>24&15]+u[i>>20&15]+u[i>>16&15]+u[i>>12&15]+u[i>>8&15]+u[i>>4&15]+u[15&i]+u[h>>28&15]+u[h>>24&15]+u[h>>20&15]+u[h>>16&15]+u[h>>12&15]+u[h>>8&15]+u[h>>4&15]+u[15&h]+u[s>>28&15]+u[s>>24&15]+u[s>>20&15]+u[s>>16&15]+u[s>>12&15]+u[s>>8&15]+u[s>>4&15]+u[15&s]+u[r>>28&15]+u[r>>24&15]+u[r>>20&15]+u[r>>16&15]+u[r>>12&15]+u[r>>8&15]+u[r>>4&15]+u[15&r]+u[e>>28&15]+u[e>>24&15]+u[e>>20&15]+u[e>>16&15]+u[e>>12&15]+u[e>>8&15]+u[e>>4&15]+u[15&e]+u[n>>28&15]+u[n>>24&15]+u[n>>20&15]+u[n>>16&15]+u[n>>12&15]+u[n>>8&15]+u[n>>4&15]+u[15&n];return this.is224||(o+=u[a>>28&15]+u[a>>24&15]+u[a>>20&15]+u[a>>16&15]+u[a>>12&15]+u[a>>8&15]+u[a>>4&15]+u[15&a]),o},t.prototype.toString=t.prototype.hex,t.prototype.digest=function(){this.finalize();var t=this.h0,i=this.h1,h=this.h2,s=this.h3,r=this.h4,e=this.h5,n=this.h6,a=this.h7,o=[t>>24&255,t>>16&255,t>>8&255,255&t,i>>24&255,i>>16&255,i>>8&255,255&i,h>>24&255,h>>16&255,h>>8&255,255&h,s>>24&255,s>>16&255,s>>8&255,255&s,r>>24&255,r>>16&255,r>>8&255,255&r,e>>24&255,e>>16&255,e>>8&255,255&e,n>>24&255,n>>16&255,n>>8&255,255&n];return this.is224||o.push(a>>24&255,a>>16&255,a>>8&255,255&a),o},t.prototype.array=t.prototype.digest,t.prototype.arrayBuffer=function(){this.finalize();var t=new ArrayBuffer(this.is224?28:32),i=new DataView(t);return i.setUint32(0,this.h0),i.setUint32(4,this.h1),i.setUint32(8,this.h2),i.setUint32(12,this.h3),i.setUint32(16,this.h4),i.setUint32(20,this.h5),i.setUint32(24,this.h6),this.is224||i.setUint32(28,this.h7),t},i.prototype=new t,i.prototype.finalize=function(){if(t.prototype.finalize.call(this),this.inner){this.inner=!1;var i=this.array();t.call(this,this.is224,this.sharedMemory),this.update(this.oKeyPad),this.update(i),t.prototype.finalize.call(this)}};var B=b();B.sha256=B,B.sha224=b(!0),B.sha256.hmac=_(),B.sha224.hmac=_(!0),a?module.exports=B:(r.sha256=B.sha256,r.sha224=B.sha224,o&&define(function(){return B}))}();

      sha256func = module.exports.sha256;
    }
    return sha256func(message);
    /* eslint-enable */
  }
})();
